import React from 'react';
import Dialog from '@material-ui/core/Dialog';

function isInteractiveControl(target) {
  if (!(target instanceof HTMLElement)) return false;

  if (target.closest('textarea, button, a, [contenteditable="true"]')) return true;
  if (target.closest('[role="button"], [role="menuitem"], [role="option"], [role="listbox"]')) {
    return true;
  }

  if (target.tagName === 'INPUT') {
    return ['button', 'checkbox', 'color', 'file', 'radio', 'range', 'reset', 'submit'].includes(
      target.type
    );
  }

  return target.tagName === 'SELECT';
}

export default function DialogWithEnterAction({
  onEnterAction,
  enterActionDisabled = false,
  onKeyDown,
  ...dialogProps
}) {
  const handleKeyDown = (event) => {
    if (onKeyDown) onKeyDown(event);

    if (
      !onEnterAction ||
      enterActionDisabled ||
      event.defaultPrevented ||
      event.key !== 'Enter' ||
      event.repeat ||
      event.isComposing ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      isInteractiveControl(event.target)
    ) {
      return;
    }

    event.preventDefault();
    onEnterAction(event);
  };

  return <Dialog {...dialogProps} onKeyDown={handleKeyDown} />;
}
